export const NAME = 'racking-list';
export const COLUMNS_CONFIG = {
    code: {
        label: 'Code',
        is_active: true,
        required: false,
    },
    name: {
        label: 'Name',
        is_active: true,
        required: true,
    },
    weight: {
        label: 'Weight',
        is_active: true,
        required: false,
    },
    data_sheet: {
        label: 'Datasheet',
        is_active: true,
        required: false,
    },
};
